import React from 'react';
import { useI18n } from '../i18n/LanguageContext';
import { LANGUAGES } from '../i18n/translations';

const SHORT = { en: 'EN', fr: 'FR', rw: 'RW' };

export default function LanguageToggle() {
  const { lang, setLang, t } = useI18n();
  return (
    <div className="lang-toggle" role="group" aria-label={t('lang.label')}>
      {LANGUAGES.map((code) => (
        <button
          key={code}
          type="button"
          className={`lang-toggle-btn ${lang === code ? 'is-active' : ''}`}
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
          title={t(`lang.${code}`)}
          lang={code}
        >
          {SHORT[code]}
        </button>
      ))}
    </div>
  );
}
